function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Form, useFormikContext } from 'formik';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParam } from 'react-use';
import { useWizard } from 'react-use-wizard';
import { Button } from '../../components/button';
import FormContainer from '../../components/containers/FormContainer';
import Control from '../../components/form/Control';
import Img from '../../components/img/Img';
import { alertConstants } from '../../redux/constants';
import routes from '../../routes/constants';
import text from '../../text';
import { larkiApiNoAuthentication } from '../../utilities/api';
import { getUser } from '../../utilities/storage';
import { isUserAnonymous } from '../../utilities/user';
import Header from './Header';
var SignupForm = function(param) {
    var onGoogleRedirect = param.onGoogleRedirect, onGoToLogin = param.onGoToLogin;
    var dispatch = useDispatch();
    var _useFormikContext = useFormikContext(), values = _useFormikContext.values, errors = _useFormikContext.errors, touched = _useFormikContext.touched, isSubmitting = _useFormikContext.isSubmitting, dirty = _useFormikContext.dirty, handleChange = _useFormikContext.handleChange, handleBlur = _useFormikContext.handleBlur, submitForm = _useFormikContext.submitForm, isValid = _useFormikContext.isValid;
    var _useWizard = useWizard(), nextStep = _useWizard.nextStep, goToStep = _useWizard.goToStep;
    var _useState = _sliced_to_array(useState(false), 2), isLoading = _useState[0], setLoading = _useState[1];
    var redirectUrl = useSearchParam('redirectUrl');
    var onRevisit = useSearchParam('onRevisit');
    var currentUser = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile
        };
    }).currentUser;
    var onSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var headers, data, is_google_account, is_verified, exists, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            8,
                            9,
                            10
                        ]);
                        event.preventDefault();
                        setLoading(true);
                        headers = {};
                        if (isUserAnonymous(currentUser)) {
                            headers['Authorization'] = "Bearer ".concat(getUser().token);
                        }
                        return [
                            4,
                            submitForm()
                        ];
                    case 1:
                        data = _state.sent();
                        if (!data) return [
                            3,
                            7
                        ];
                        is_google_account = data.is_google_account, is_verified = data.is_verified, exists = data.exists;
                        if (!!exists) return [
                            3,
                            2
                        ];
                        nextStep(); //user does not exist, go to create new account
                        return [
                            3,
                            7
                        ];
                    case 2:
                        if (!is_google_account) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            onGoogleRedirect()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        if (is_verified) {
                            onGoToLogin(values.email);
                        }
                        _state.label = 5;
                    case 5:
                        if (!!is_verified) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            larkiApiNoAuthentication.post('/user/send-verification-email', _object_spread({}, values, redirectUrl && {
                                redirectUrl: redirectUrl
                            }, onRevisit && {
                                onRevisit: onRevisit
                            }), {
                                headers: headers
                            })
                        ];
                    case 6:
                        _state.sent();
                        sessionStorage.clear();
                        goToStep(2);
                        _state.label = 7;
                    case 7:
                        return [
                            3,
                            10
                        ];
                    case 8:
                        error = _state.sent();
                        dispatch({
                            type: alertConstants.ALERT_ERROR,
                            payload: {
                                message: error.response.data.message
                            }
                        });
                        return [
                            3,
                            10
                        ];
                    case 9:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var onRedirect = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            onGoogleRedirect()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onRedirect() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(FormContainer, {
        className: "SignupForm"
    }, /*#__PURE__*/ React.createElement(FormContainer.SecondaryHeader, {
        isSecondary: true
    }, /*#__PURE__*/ React.createElement(Header, null)), /*#__PURE__*/ React.createElement(FormContainer.Body, null, /*#__PURE__*/ React.createElement(FormContainer.PrimaryHeader, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h2", null, text('welcomeToLarki'))), /*#__PURE__*/ React.createElement("p", null, text('chooseOptionsToGetStarted'))), /*#__PURE__*/ React.createElement(Form, {
        noValidate: true,
        onSubmit: onSubmit
    }, /*#__PURE__*/ React.createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ React.createElement("a", {
        onClick: onRedirect,
        className: "signin-btn"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "signin-iconbtn"
    }, /*#__PURE__*/ React.createElement("img", {
        src: "/public/img/icon-google.svg",
        alt: "Image not present"
    })), ' ', text('signUpLoginWithGoogle'))), /*#__PURE__*/ React.createElement("div", {
        className: "or"
    }, /*#__PURE__*/ React.createElement("span", null, text('or'))), /*#__PURE__*/ React.createElement(Control, {
        validationError: errors.email,
        as: "input",
        type: "text",
        name: "email",
        label: text('email'),
        value: (values === null || values === void 0 ? void 0 : values.email) || '',
        onChange: handleChange,
        onBlur: handleBlur,
        placeholder: text('enterEmail'),
        isFailed: touched.email && Boolean(errors.email)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "btns-group"
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "full-width",
        loading: isSubmitting || isLoading,
        disabled: !dirty || !isValid,
        onClick: onSubmit
    }, text('signUpLogin'))), /*#__PURE__*/ React.createElement("p", {
        className: "small-text"
    }, text('createAccountByline'), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("a", {
        href: process.env.LARKI_URL_TERMS,
        target: "_blank",
        rel: "noreferrer"
    }, text('termsOfUse')), ' ', text('and'), ' ', /*#__PURE__*/ React.createElement("a", {
        href: routes.larkiWebsiteUrl.privacy,
        target: "_blank",
        rel: "noreferrer"
    }, text('privacyPolicy'))))), /*#__PURE__*/ React.createElement(Img, {
        id: "laptop-larki-form",
        img: "laptop-larki-app"
    })));
};
export default SignupForm;
